import { Link as RouterLink } from "react-router-dom";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import {
  LegalNoticeSubsection,
  LegalNoticeText,
} from "src/components/LegalNotice";
import { IArticleConfig } from "src/components/LegalNotice/types";
import { PROMOTION_URL } from "src/config";

export const TOS_ARTICLES: IArticleConfig[] = [
  {
    title: "Certain Defined Terms",
    content: (
      <ul>
        <li>
          &ldquo;Blockchain&rdquo; means a Blockchain or distributed ledger
          technology or other similar technology.
        </li>
        <li>
          &ldquo;Blockchain System&rdquo; means the combination of (i) a
          Blockchain; and (ii) a network of one or more devices operating
          software clients or software applications that jointly or individually
          store, validate, process transactions with respect to, update, resolve
          forks with respect to or otherwise maintain, validate, read from,
          store data with respect to, create public proofs with respect to, or
          write to such Blockchain.
        </li>
        <li>
          &ldquo;Blockchain Tokens&rdquo; or &ldquo;Tokens&rdquo; means virtual
          currencies, Blockchain digital assets and other units of account or
          mediums of exchange that are implemented on a Blockchain.
        </li>
        <li>
          &ldquo;Host Blockchain Systems&rdquo; means each Blockchain to which
          any Third Party Protocol Smart Contract is deployed.
        </li>
        <li>
          &ldquo;Third Party Protocol&rdquo; has the meaning assigned in Section
          C.
        </li>
        <li>
          &ldquo;Terminal Smart Contracts&rdquo; means all Smart Contracts that
          are deployed to production Blockchain network by Terminal Operator.
        </li>
        <li>
          &ldquo;Terminal&rdquo; means the web site, web pages, web applications
          and information and software available at or accessible through the
          URL https:www.padre.gg or any sub-URL of such URL and any other
          Terminal website or web application maintained by Terminal.
        </li>
        <li>
          &ldquo;Smart Contract&rdquo; means Smart Contract bytecode deployed to
          a Blockchain such that a copy of such bytecode is stored by the
          Blockchain and the nodes (or a subset thereof) on such Blockchain
          System validate and effectuate state transitions of such bytecodes as
          part of the consensus rules of such Blockchain.
        </li>
        <li>
          &ldquo;Third Party Smart Contract Systems&rdquo; means Smart Contract
          systems not deployed by Terminal.
        </li>
      </ul>
    ),
  },
  {
    title: "Terminal Operator Discretion; Certain Risks of Terminal",
    content: (
      <>
        <LegalNoticeText>
          Each User hereby acknowledges and agrees and consents to, and assumes
          the risks of, the matters described in this Section 2.
        </LegalNoticeText>
        <LegalNoticeSubsection title="Content">
          <LegalNoticeText>
            Terminal Operator makes no representations or warranties as to the
            quality, origin, or ownership of any content found on or available
            through Terminal. Terminal Operator shall not be liable for any
            errors, misrepresentations, or omissions in, of, and about, the
            content, nor for the availability of the content. Terminal Operator
            shall not be liable for any losses, injuries, or damages from the
            purchase, inability to purchase, display, or use of content.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Token Lists and Token Identification">
          <LegalNoticeText>
            In providing information about Blockchain digital assets, Terminal
            associates or presumes the association of a token name, symbol or
            logo with a specific Smart Contract deployed to one or more
            Blockchain Systems. In making such associations, Terminal relies
            upon third-party resources which may not be accurate or may not
            conform to a given User&rsquo;s expectations. Multiple Smart
            Contracts can utilize the same Blockchain Token name or symbol as
            one another, meaning that the name or symbol of a Blockchain Token
            does not guarantee that it is the digital asset desired by the User
            or generally associated with such name or symbol. Users must not
            rely on the name, symbol or branding of a digital asset on Terminal,
            but instead must examine the specific Smart Contract associated with
            the name, symbol or branding and confirm that the digital asset
            accords with User&rsquo;s expectations.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="User Responsibility for Accounts &amp; Security">
          <LegalNoticeText>
            Users are solely responsible for all matters relating to their
            accounts, addresses and Blockchain digital assets and for ensuring
            that all uses thereof comply fully with these Terms. Users are
            solely responsible for protecting the data integrity and
            confidentiality of their login information and passwords or private
            keys for Terminal or any wallet applications or devices used in
            connection with Terminal. The compatibility of Terminal with wallet
            applications and devices or other third-party applications or
            devices is not intended as, and you hereby agree not to construe
            such compatibility as, an endorsement or recommendation thereof or a
            warranty, guarantee, promise or assurance regarding the fitness or
            security thereof.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Smart Contract Fees Irreversible">
          <LegalNoticeText>
            Use of the Third Party Protocols and use of Blockchain network and
            Third Party Smart Contract Systems may be subject to transaction
            fees, some or all of which may be paid to parties other than
            Terminal Operators. Terminal Operator has no ability to reverse or
            refund any fees not paid directly and solely to the Terminal
            Operator. Any fees paid to Terminal Operator are non-refundable
            except in the sole and absolute discretion of Terminal Operator.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Terminal Operator Has No Business Plan and May Discontinue, Limit, Terminate or Refuse Support for the Terminal Site or any Smart Contracts or digital assets">
          <LegalNoticeText>
            Terminal is a web application operated and maintained in the sole
            and absolute discretion of Terminal Operator. Terminal Operator
            assumes no duties, liabilities, obligations or undertakings to Users
            to continue operating or maintaining the availability of Terminal
            and may terminate or change Terminal in any or all respects at any
            time.
          </LegalNoticeText>
          <LegalNoticeText>
            Terminal Operator has no obligation to ensure that Terminal is a
            complete and accurate source of all information relating to the
            Third Party Protocols, Blockchain network, Third Party Smart
            Contract Systems or any other subject matter. Terminal does not
            necessarily display all Blockchain digital assets that are available
            for trading in connection with Third Party Protocols or Blockchain
            network or Third Party Smart Contract Systems. Even if Terminal
            currently displays a particular trading pair, Terminal may
            discontinue tracking and publishing information about that trading
            pair at any time, in Terminal Operator&rsquo;s sole and absolute
            discretion.
          </LegalNoticeText>
          <LegalNoticeText>
            In the event of such a discontinuation, Users may need to rely on
            third-party resources such as block explorers in order to get
            equivalent information, and, depending on the User&rsquo;s level of
            expertise and the quality of such third-party resources, this may
            result in the User incurring financial losses due to delays or
            mistakes in processing information or transactions. Even if Terminal
            Operator has any such obligations under any external written
            agreements outside of these Terms, Users are not beneficiaries of
            and do not have any rights under any such written agreements.
          </LegalNoticeText>
          <LegalNoticeText>
            Third Party Protocols are available under a free open-source
            license, and Terminal Operator does not have proprietary or
            exclusive rights in all copies or derivatives thereof. It is
            possible that additional copies of the Third Party Protocols or
            derivatives thereof will be deployed to other Blockchain network in
            the future by any person, resulting in the existence of multiple
            &lsquo;Third Party Protocols-branded&rsquo; Blockchain network or
            Smart Contract systems. Terminal Operator is under no obligation to
            publish information for all such copies of the Third Party Protocols
            Protocol or to warn Users regarding the existence of such
            alternatives.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Terminal Operator may Suspend, Block, or Limit Access on a Targeted Basis">
          <LegalNoticeText>
            Terminal Operator reserves the right to terminate or limit any
            person&rsquo;s User status or access to or use of Terminal at any
            time, with or without notice, as determined in Terminal
            Operator&rsquo;s sole and absolute discretion. Such terminations and
            limitations may be based on any factor or combination of factors,
            including a person&rsquo;s identity, Blockchain address, IP address,
            internet service provider, virtual provider network provider,
            metadata, browser software, device type, wallet application, wallet
            device, region of citizenship or residence or current location, or
            suspicion that User has engaged or intends to engage in any
            Prohibited Use.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Terminal Operator May Cooperate with Investigations and Disclose Information">
          <LegalNoticeText>
            Terminal Operator reserves the right at all times to cooperate with
            any governmental or law enforcement investigation or to disclose any
            information it deems necessary to satisfy any applicable law,
            regulation, legal process or governmental request, or to edit,
            refuse to post or to remove any information or materials, in whole
            or in part, based on any applicable law, regulation, legal process
            or governmental request, in Terminal Operator&rsquo;s sole and
            absolute discretion.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="No Regulatory Supervision">
          <LegalNoticeText>
            Terminal Operator and Terminal are not registered or qualified with
            or licensed by, do not report to and are not under the active
            supervision of any government agency or financial regulator or other
            similar organization. No government or regulator has approved or
            consulted with Terminal Operator regarding the accuracy or
            completeness of any information available on Terminal. Similarly,
            the technology, systems, Blockchain digital assets and persons
            relevant to information published on Terminal may not be registered
            with or under the active supervision of or be registered or
            qualified with or licensed by any government agency or financial
            regulator or other similar organization. Terminal Operator is not
            registered as a broker, dealer, advisor, exchange, transfer agent or
            other intermediary.
          </LegalNoticeText>
        </LegalNoticeSubsection>
      </>
    ),
  },
  {
    title: "Intellectual Property Matters",
    content: (
      <>
        <LegalNoticeSubsection title="License to Use Terminal">
          <LegalNoticeText>
            Each User, subject to and conditioned upon such User&rsquo;s
            eligibility under and acceptance of and adherence to these Terms, is
            hereby granted a personal, revocable, non-exclusive,
            non-transferable, non-sub-licensable license to view, access and use
            Terminal for the Permitted Uses in accordance with these Terms.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Marks, Logos and Branding">
          <LegalNoticeText>
            All Third Party Protocols-related marks, logos and branding used on
            Terminal are proprietary and are prohibited from being used,
            reproduced, or copied without the express written consent of
            Terminal Operator. All other marks, logos and branding appearing on
            Terminal (including token names, symbols and logos identified on
            Terminal which may trade in connection with the Third Party
            Protocols Smart Contract System) are the property of their
            respective owners.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Privacy Policy">
          <LegalNoticeText>
            Terminal Operator may directly or indirectly collect and temporarily
            store personally identifiable information for operational purposes,
            including for the purpose of identifying Blockchain addresses or IP
            addresses that may indicate use of Terminal from prohibited
            jurisdictions or by sanctioned persons or other prohibited person.
            Except as required by applicable law, Terminal Operator will have no
            obligation of confidentiality with respect to any information
            collected by Terminal.
          </LegalNoticeText>
        </LegalNoticeSubsection>
      </>
    ),
  },
  {
    title: "Permitted & Prohibited Uses",
    content: (
      <>
        <LegalNoticeSubsection title="Permitted Uses">
          <LegalNoticeText>
            Terminal is available exclusively for use by technologically and
            financially sophisticated persons who wish to use Terminal for
            lawful informational purposes only as an aid to their own research,
            due diligence and financial decision making. Before utilizing
            information from Terminal (including any draft transaction messages)
            to engage in transactions, each User must independently verify the
            accuracy of such information (and the consistency of such draft
            transaction messages with the User&rsquo;s intentions). The
            foregoing are the &ldquo;Permitted Uses&rdquo;.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Prohibited Uses">
          <LegalNoticeText>
            Each User must not, directly or indirectly, in connection with their
            use of Terminal:
          </LegalNoticeText>
          <ul>
            <li>utilize Terminal other than for the Permitted Uses;</li>
            <li>
              utilize Terminal at any time when any representation of User set
              forth in Section 5 is untrue or inaccurate;
            </li>
            <li>
              rely on Terminal as a basis for or a source of advice concerning
              any financial decision making or transactions;
            </li>
            <li>
              employ any device, scheme or artifice to defraud, or otherwise
              materially mislead, any person;
            </li>
            <li>
              engage in any act, practice or course of business that operates or
              would operate as a fraud or deceit upon Terminal Operator or any
              other person;
            </li>
            <li>
              violate, breach or fail to comply with any applicable provision of
              these Terms or any other terms of service, privacy policy, trading
              policy or other contract governing the use of Terminal;
            </li>
            <li>
              engage or attempt to engage in or assist any hack of or attack on
              Terminal or any wallet application or device, including any “sybil
              attack” , “DoS attack” or “griefing attack” or theft;
            </li>
            <li>
              commit any violation of applicable laws, rules or regulations;
            </li>
            <li>
              engage in or knowingly facilitate any “front-running”, “wash
              trading”, “pump and dump trading”, “ramping”, “cornering” or
              fraudulent, deceptive or manipulative trading activities,
              including: o trading at successively lower or higher prices for
              the purpose of creating or inducing a false, misleading or
              artificial appearance of activity, unduly or improperly
              influencing market prices or establishing a price which does not
              reflect the true state of the market; o trading without changes in
              material beneficial ownership for the purpose of creating or
              inducing a false or misleading appearance of trading activity or
              creating or inducing a false or misleading appearance with respect
              to market conditions; or
            </li>
            <li>
              participating in, facilitating, assisting or knowingly transacting
              with any pool, syndicate or joint account organized for the
              purpose of unfairly or deceptively influencing market prices;
            </li>
            <li>
              transact in securities, commodities futures, trading of
              commodities on a leveraged, margined or financed basis, binary
              options (including prediction-market transactions), real estate or
              real estate leases, equipment leases, debt financings, equity
              financings or other similar transactions, in each case, if such
              transactions do not comply with all laws, rules and regulations
              applicable to the parties and assets engaged therein;
            </li>
            <li>
              engage in token-based or other financings of a business,
              enterprise, venture, company, software development project or
              other initiative, including ICOs, DAICOs, IEOs, or other
              token-based fundraising events, if such transactions do not comply
              with all laws, rules and regulations applicable to the parties and
              assets engaged therein; or
            </li>
            <li>
              engage in any act, practice or course of business that operates to
              circumvent any sanctions or export controls targeting the User or
              the country or territory where User is located.
            </li>
          </ul>
          <LegalNoticeText>
            The foregoing matters are referred to herein as &ldquo;Prohibited
            Uses&rdquo;.
          </LegalNoticeText>
        </LegalNoticeSubsection>
      </>
    ),
  },
  {
    title: "Representations and Warranties of Users",
    content: (
      <>
        <LegalNoticeText>
          By using Terminal, each User represents and warrants to Terminal
          Operator that the following statements and information are accurate
          and complete at all relevant times. In the event that any such
          statement or information becomes untrue as to a User, User shall
          immediately cease accessing and using Terminal.
        </LegalNoticeText>
        <LegalNoticeSubsection title="Adult Status; Capacity; Residence; Etc.">
          <LegalNoticeText>
            If User is an individual, User is of legal age in the jurisdiction
            in which User resides (and in any event is older than eighteen years
            of age) and is of sound mind. If User is a business entity, User is
            duly organized, validly existing and in good standing under the laws
            of the jurisdiction in which it is organized, and has all requisite
            power and authority for a business entity of its type to carry on
            its business as now conducted.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Power and Authority">
          <LegalNoticeText>
            User has all requisite capacity, power and authority to accept the
            terms and conditions of these Terms and to carry out and perform its
            obligations under these Terms. These Terms constitute a legal, valid
            and binding obligation of User enforceable against User in
            accordance with its terms.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="No Conflict; Compliance with Law">
          <LegalNoticeText>
            User agreeing to these Term and using Terminal does not constitute,
            and would not reasonably be expected to result in (with or without
            notice, lapse of time, or both) a breach, default, contravention or
            violation of any law applicable to User, or contract or agreement to
            which User is a party or by which User is bound.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Absence of Sanctions">
          <LegalNoticeText>
            User is not, (and, if User is an entity, User is not owned or
            controlled by any other person who is), and is not acting on behalf
            of any other person who is, located, ordinarily resident, organized,
            established, or domiciled in any country where use of Terminal, the
            Third Party Protocols, Blockchain network, Third Party Smart
            Contract Systems or related activities is illegal, prohibited, or
            requires a permit or license that is not held by the User. User is
            not (and, if User is an entity, User is not owned or controlled by
            any other person who is), and is not acting on behalf of any other
            person who is, identified on any list of prohibited parties under
            any law or by any nation or government, state or other political
            subdivision thereof, any entity exercising legislative, judicial or
            administrative functions of or pertaining to government such as the
            sanctions lists maintained by the United States, United Kingdom,
            British Virgin Islands, United Nations Security Council, the U.S.
            government (including the U.S. Treasury Department&rsquo;s Specially
            Designated Nationals list and Foreign Sanctions Evaders list), or
            the European Union (EU) or its member states. The Blockchain digital
            assets or other funds, money, or monetary equivalents User uses to
            participate in Terminal, Third Party Protocols, Blockchain network
            or Third Party Smart Contract Systems are not derived from, and do
            not otherwise represent the proceeds of, any activities done in
            violation or contravention of any law.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Non-Reliance">
          <LegalNoticeText>
            User is knowledgeable, experienced and sophisticated in using and
            evaluating Blockchain and related technologies and assets, including
            Third Party Smart Contract Systems, Blockchain digital assets,
            yield-generating Smart Contract systems, automated market making
            Smart Contract systems, and bonding curve systems. User has
            conducted its own thorough independent investigation and analysis of
            the Blockchain network, Third Party Smart Contract Systems and the
            other matters contemplated by these Terms, and has not relied upon
            any information, statement, omission, representation or warranty,
            express or implied, written or oral, made by or on behalf of
            Terminal Operator in connection therewith, except as expressly set
            forth by Terminal Operator in these Terms.
          </LegalNoticeText>
        </LegalNoticeSubsection>
      </>
    ),
  },
  {
    title: "Risks, Disclaimers and Limitations of Liability",
    content: (
      <>
        <LegalNoticeText>
          Each User hereby acknowledges and agrees and consents to, and assumes
          the risks of, the matters described in this Section 6.
        </LegalNoticeText>
        <LegalNoticeSubsection title="No Consequential, Incidental or Punitive Damages">
          <LegalNoticeText>
            Notwithstanding anything to the contrary contained on Terminal, in
            these Terms, or in any other agreement or publication, Terminal
            Operator shall not be liable to any person, whether in contract,
            tort (including pursuant to any cause of action alleging
            negligence), warranty or otherwise, for any economic or other
            damages to any User or other person, including any special,
            incidental, consequential, indirect, punitive or exemplary damages
            (including but not limited to lost data, lost profits or savings,
            loss of business or other economic loss) arising out of or related
            to these Terms, whether or not Terminal Operator has been advised or
            knew of the possibility of such damages, and regardless of the
            nature of the cause of action or theory asserted.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Disclaimer of Representations">
          <LegalNoticeText>
            Terminal is being provided on an &ldquo;AS IS&rdquo; and &ldquo;AS
            AVAILABLE&rdquo; basis. To the fullest extent permitted by law,
            Terminal Operator is not making, and hereby disclaims, any and all
            information, statements, omissions, representations and warranties,
            express or implied, written or oral, equitable, legal or statutory,
            in connection with Terminal and the other matters contemplated by
            these Terms, including any representations or warranties of title,
            non-infringement, merchantability, usage, security, uptime,
            reliability, suitability or fitness for any particular purpose,
            workmanship or technical quality of any code or software used in or
            relating to Terminal.
          </LegalNoticeText>
          <LegalNoticeText>
            User acknowledges and agrees that use of Terminal is at the
            User&rsquo;s own risk.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="No Responsibility for digital assets or tokens; No guarantee of Uniqueness or IP">
          <LegalNoticeText>
            Terminal Operator has no responsibility for the Blockchain digital
            assets traded by Users on the Third Party Protocols or Blockchain
            network or Third Party Smart Contract Systems. Terminal Operator
            does not investigate and cannot guarantee or warrant the
            authenticity, originality, uniqueness, marketability, legality or
            value of any tokens or digital assets traded by Users on the Third
            Party Protocols or Blockchain network or Third Party Smart Contract
            Systems, even if information about such token is available on
            Terminal.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="No Professional Advice or Liability">
          <LegalNoticeText>
            All information provided by or on behalf of Terminal Operator is for
            informational purposes only and should not be construed as
            professional, accounting or legal advice. Users should not take or
            refrain from taking any action in reliance on any information
            contained in these Terms or provided by or on behalf of Terminal
            Operator.
          </LegalNoticeText>
          <LegalNoticeText>
            Before Users make any financial, legal, or other decisions involving
            Terminal, Users should seek independent professional advice from
            persons licensed and qualified in the area for which such advice
            would be appropriate.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Limited Survival Period for Claims">
          <LegalNoticeText>
            Any claim or cause of action a User may have or acquire in
            connection with Terminal or any of the other matters contemplated by
            these Terms shall survive for the shorter of, and may be brought
            against Terminal Operator solely prior to: (a) the expiration of the
            statute of limitations applicable thereto; and (b) the date that is
            six months after the date on which the facts and circumstances
            giving rise to such claim or cause of action first arose.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Third-Party Offerings and Content">
          <LegalNoticeText>
            References, links or referrals to or connections with or reliance on
            third-party resources, products, services or content, including
            Smart Contracts developed or operated by third parties, may be
            provided to Users in connection with Terminal. In addition, third
            parties may offer promotions related to Terminal. Terminal Operator
            does not endorse or assume any responsibility for any activities of
            or resources, products, services, content or promotions owned,
            controlled, operated or sponsored by third parties. If Users access
            any such resources, products, services or content or participate in
            any such promotions, Users do so solely at their own risk. Each User
            hereby expressly waives and releases Terminal Operator from all
            liability arising from User&rsquo;s use of any such resources,
            products, services or content or participation in any such
            promotions. User further acknowledges and agrees that Terminal
            Operator shall not be responsible or liable, directly or indirectly,
            for any damage or loss caused or alleged to be caused by or in
            connection with use of or reliance on any such resources, products,
            services, content or promotions from third parties.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Certain Uses and Risks of Blockchain Technology">
          <LegalNoticeText>
            <strong>(a) Use of Blockchain Technology.</strong> Terminal Operator
            or third parties may utilize experimental cryptographic technologies
            and Blockchain technologies, including Blockchain digital assets,
            cryptocurrencies, stablecoins, consensus algorithms, voting systems
            and distributed, decentralized or peer-to-peer networks or systems
            in connection with Terminal or systems about which Terminal provides
            information. Each User acknowledges and agrees that such
            technologies are novel, experimental, and speculative, and that
            therefore there is significant uncertainty regarding the operation
            and effects and risks thereof and the application of existing law
            thereto.
          </LegalNoticeText>
          <LegalNoticeText>
            <strong>(b) Certain Risks of Blockchain Technology.</strong> The
            technologies relevant to Terminal depend on public peer-to-peer
            networks such as Blockchain network and the Third Party Smart
            Contract Systems that are not under the control or influence of
            Terminal Operator and are subject to many risks and uncertainties.
            Such technologies include the Third Party Protocols, which (other
            than based on any multisignature arrangements that may apply)
            Terminal Operator has no ability to change, other than ceasing to
            display information about certain Smart Contracts or adding
            information about new Smart Contracts. Users are solely responsible
            for the safekeeping of the private key associated with the
            Blockchain address used in connection with the Third Party
            Protocols. Terminal Operator will not be able to restore or issue
            any refund in respect of property lost or frozen due to loss of
            private keys or otherwise. If a User is not able to spend or use
            Blockchain digital assets due to loss of the corresponding private
            key or otherwise, a User will be unable to enjoy the benefits of
            such Blockchain digital assets.
          </LegalNoticeText>
          <LegalNoticeText>
            <strong>(c) Certain Risks of Smart Contract Technology.</strong>{" "}
            Digital assets relevant to Terminal depend on the Third Party
            Protocols or other Smart Contracts deployed to Third Party Smart
            Contract Systems or other Blockchain network, or on the Blockchain
            network, each of which may be coded or deployed by persons other
            than Terminal Operator. Blockchain network, Third Party Smart
            Contract Systems, and other Blockchain Systems, and, once deployed
            to a Blockchain, the code of Smart Contracts, including the Third
            Party Protocols, typically cannot be modified, or can only be
            modified in limited ways. In the event that the Blockchain network,
            Third Party Smart Contract Systems, Third Party Protocols or other
            Smart Contracts or Blockchain network are adversely affected by
            malfunctions, bugs, defects, negligent coding or design choices, or
            changes to the applicable protocol rules, Users may be exposed to a
            risk of total loss and forfeiture of all relevant digital assets.
            Terminal Operator assumes no liability or responsibility for any of
            the foregoing matters.
          </LegalNoticeText>
          <LegalNoticeText>
            <strong>(d) Asset Prices.</strong> The fiat-denominated prices and
            value in public markets of cryptocurrencies and Blockchain digital
            assets have historically been subject to dramatic fluctuations and
            may be highly volatile. As relatively new products and technologies,
            digital based assets are not widely accepted as a means of payment
            for goods and services. A significant portion of demand for these
            assets is generated by speculators and investors seeking to profit
            from the short- or long-term holding of Blockchain assets. The
            market value of any token may decline below the price for which a
            User acquires such asset through the Blockchain network, Third Party
            Smart Contract Systems or Third Party Protocols or on any other
            system. User acknowledges and agrees that the costs and speeds of
            transacting with cryptographic and systems such as the Blockchain
            network, Third Party Smart Contract Systems and Third Party
            Protocols are variable and may increase or decrease dramatically at
            any time, resulting in prolonged inability to access or use any
            Blockchain digital assets.
          </LegalNoticeText>
          <LegalNoticeText>
            <strong>(e) Regulatory Uncertainty.</strong> Blockchain technologies
            and digital assets are subject to many legal and regulatory
            uncertainties, and the Blockchain network, Third Party Smart
            Contract Systems, Third Party Protocols or any Blockchain digital
            assets could be adversely impacted by one or more regulatory or
            legal inquiries, actions, suits, investigations, claims, fines or
            judgments, which could impede or limit the ability of User to
            continue the use and enjoyment of such assets and technologies.
          </LegalNoticeText>
          <LegalNoticeText>
            <strong>(f) Cryptography Risks.</strong> Cryptography is a
            progressing field. Advances in code cracking or technical advances
            such as the development of quantum computers may present risks to
            Blockchain network, the Blockchain Systems, Third Party Smart
            Contract Systems, Third Party Protocols or Blockchain digital
            assets, including the loss or inaccessibility thereof.
          </LegalNoticeText>
          <LegalNoticeText>
            <strong>(g) Fork Handling.</strong> Blockchain network, Third Party
            Smart Contract Systems, the Third Party Protocols Smart Contract
            System, and all Blockchain digital assets may be subject to
            &ldquo;forks.&rdquo; Forks occur when some or all persons running
            the software clients for a particular Blockchain adopt a new client
            or a new version of an existing client that: (i) changes the
            protocol rules in backwards-compatible or backwards-incompatible
            manner that affects which transactions can be added into later
            blocks, how later blocks are added to the Blockchain, or other
            matters relating to the future operation of the protocol; or (ii)
            reorganizes or changes past blocks to alter the history of the
            Blockchain. Some forks are &ldquo;contentious&rdquo; and thus may
            result in two or more persistent alternative versions of the
            protocol or Blockchain, either of which may be viewed as or claimed
            to be the legitimate or genuine continuation of the original.
            Terminal Operator may not be able to anticipate, control or
            influence the occurrence or outcome of forks, and does not assume
            any risk, liability or obligation in connection therewith. Without
            limiting the generality of the foregoing, Terminal Operator does not
            assume any responsibility to notify a User of pending, threatened or
            completed forks. Terminal Operator will respond (or refrain from
            responding) to any forks in such manner as Terminal Operator
            determines in its sole and absolute discretion, and Terminal
            Operator shall not have any duty or obligation or liability to a
            User if such response (or lack of such response) acts to a User
            detriment. Without limiting the generality of the foregoing,
            Terminal Operator&rsquo;s possible and permissible responses to a
            fork may include: (i) honoring the Blockchain network, Third Party
            Smart Contract Systems, Third Party Protocols and Blockchain digital
            assets on both chains; (ii) honoring the Blockchain network, Third
            Party Smart Contract Systems, Third Party Protocols and Blockchain
            digital assets on only one of the chains; (iii) honoring the
            Blockchain network, Third Party Smart Contract Systems, Third Party
            Protocols and Blockchain digital assets in different respects or to
            a different extent on both chains; or (iv) any other response or
            policy or procedure, as determined by Terminal Operator in its sole
            and absolute discretion. Each User assumes full responsibility to
            independently remain apprised of and informed about possible forks,
            and to manage the User&rsquo;s own interests and risks in connection
            therewith.
          </LegalNoticeText>
          <LegalNoticeText>
            <strong>(h) Essential third-party Software Dependencies.</strong>{" "}
            The Blockchain network, Third Party Smart Contract Systems, Third
            Party Protocols and other relevant Blockchain network and Smart
            Contracts are public software utilities which are accessible
            directly through any compatible node or indirectly through any
            compatible &ldquo;wallet&rdquo; application (such as the web browser
            plugin wallet) which interacts with such a node. Interacting with
            the Third Party Protocols does not require use of Terminal, but
            Terminal provides a convenient and user-friendly method of reading,
            interacting with and displaying data from the Third Party Protocols
            and generating standard transaction messages compatible with the
            Third Party Protocols Smart Contract System. Because Terminal does
            not provide wallet software or nodes for Blockchain network or Third
            Party Smart Contract Systems, such software constitutes an essential
            third-party or user dependency without which the Third Party
            Protocols cannot be utilized, and Blockchain digital assets cannot
            be traded or used. Furthermore, Terminal may utilize APIs,
            middleware and servers of Terminal Operator or third parties, and
            Terminal Operator does not guarantee the continued operation,
            maintenance, availability or security of any of the foregoing
            dependencies.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Tax Issues">
          <LegalNoticeText>
            The tax consequences of purchasing, selling, holding, transferring
            or locking Blockchain digital assets or otherwise utilizing the
            Third Party Protocols are uncertain, may vary by jurisdiction and
            may be adverse to a User. Terminal Operator has undertaken no due
            diligence or investigation into such tax consequences, assumes no
            obligation or liability to optimize the tax consequences to any
            person and is not providing any tax advice.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Legal Limitations on Disclaimers">
          <LegalNoticeText>
            Some jurisdictions do not allow the exclusion of certain warranties
            or the limitation or exclusion of certain liabilities and damages.
            Accordingly, some of the disclaimers and limitations set forth in
            these Terms may not apply in full to specific Users. The disclaimers
            and limitations of liability provided in these terms shall apply to
            the fullest extent permitted by applicable law.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Officers, Directors, Etc.">
          <LegalNoticeText>
            All provisions of these Terms which disclaim or limit obligations or
            liabilities of Terminal Operator shall also apply, mutatis mutandis,
            to the officers, directors, members, employees, accountants,
            attorneys, independent contractors, agents, stockholders,
            debtholders and affiliates of Terminal Operator.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Indemnification">
          <LegalNoticeText>
            Each User shall defend, indemnify, compensate, reimburse and hold
            harmless Terminal Operator (and each of its officers, directors,
            members, employees, agents and affiliates) from any claim, demand,
            action, damage, loss, cost or expense, including without limitation
            reasonable attorneys&rsquo; fees, arising out or relating to (a)
            User&rsquo;s use of, or conduct in connection with, Terminal; (b)
            User&rsquo;s violation of these Terms or any other applicable policy
            or contract of Terminal Operator; or (c) User&rsquo;s violation of
            any rights of any other person or entity in connection with use of
            Terminal.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Exclusion of Damages">
          <LegalNoticeText>
            To the fullest extent permitted by applicable law, Terminal Operator
            shall not be liable for any indirect, incidental, consequential,
            special, punitive, or exemplary damages, including but not limited
            to loss of profits, loss of digital assets, loss of data, loss of
            goodwill, or business interruption, even if Terminal Operator has
            been advised of the possibility of such damages.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Limitation of Liability">
          <LegalNoticeText>
            To the maximum extent permitted by applicable law, the total
            aggregate liability of Terminal Operator for all claims arising out
            of or relating to these Terms or the use of Terminal shall not
            exceed the greater of:
          </LegalNoticeText>
          <LegalNoticeText>
            (a) one hundred U.S. dollars (USD $100); or
          </LegalNoticeText>
          <LegalNoticeText>
            (b) the total amount (if any) paid by the User to Terminal Operator
            in the six (6) months preceding the event giving rise to the claim.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="No Custody; No Control of Assets">
          <LegalNoticeText>
            Terminal is a non-custodial interface. Terminal Operator does not
            hold, access, or control any digital assets, private keys, or user
            funds. Users are solely responsible for the custody and security of
            their assets. Terminal Operator shall have no liability for any loss
            or inability to access digital assets.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Blockchain and Smart Contract Risks">
          <LegalNoticeText>
            User acknowledges that Blockchain technologies and Smart Contracts
            are experimental and may be subject to bugs, vulnerabilities, or
            other failures. Terminal Operator does not develop or control Third
            Party Smart Contracts and assumes no liability for any losses
            arising from their use.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Assumption of Risk">
          <LegalNoticeText>
            The User assumes the entire risk arising out of or relating to the
            use of Terminal and any interaction with Blockchain systems or Third
            Party Protocols.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Site Promotions">
          <LegalNoticeText>
            NO PURCHASE, PAYMENT, OR PARTICIPATION NECESSARY TO ENTER OR WIN.
            MAKING A PURCHASE OR PARTICIPATING IN ANY PRODUCT OR SERVICE WILL
            NOT INCREASE YOUR CHANCES OF WINNING. VOID WHERE PROHIBITED OR
            RESTRICTED BY LAW. THE PROMOTION IS SUBJECT TO ALL APPLICABLE
            FEDERAL, STATE, AND LOCAL LAWS AND REGULATIONS. PARTICIPATION IN
            BLOCKCHAIN TRANSACTIONS OR USE OF ANY DIGITAL ASSET IS NOT REQUIRED
            FOR ENTRY. Full Promotion rules are available{" "}
            <Link
              component={RouterLink}
              to={PROMOTION_URL}
              underline="always"
              fontWeight="inherit"
            >
              here
            </Link>
            .
          </LegalNoticeText>
        </LegalNoticeSubsection>
      </>
    ),
  },
  {
    title: "Governing Law; Dispute Resolution",
    content: (
      <>
        <LegalNoticeSubsection title="Governing Law">
          <LegalNoticeText>
            These Terms shall be governed by and construed and interpreted in
            accordance with the laws of the British Virgin Islands (irrespective
            of the choice of laws principles) as to all matters, including
            matters of validity, construction, effect, enforceability,
            performance and remedies. Although Terminal may be available in
            other jurisdictions, each User hereby acknowledges and agrees that
            such availability shall not be deemed to give rise to general or
            specific personal jurisdiction over Terminal Operator in any forum
            outside of the British Virgin Islands.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Settlement Negotiations">
          <LegalNoticeText>
            If a User has a potential legal dispute, claim or cause of action
            against Terminal Operator, the User shall first (prior to initiating
            any litigation proceedings) contact Terminal Operator by sending an
            email to{" "}
            <Box component="span" sx={{ color: "primary.main" }}>
              notices@padre.gg
            </Box>{" "}
            describing the nature of the potential dispute, claim or cause of
            action and providing all relevant documentation and evidence
            thereof. If so elected by Terminal Operator, User shall use
            commercially reasonable efforts to negotiate a settlement of any
            such legal dispute, claim or cause of action within 60 days of the
            delivery of such email. Any such dispute, claim or cause of action
            that is not finally resolved by a binding, written settlement
            agreement within such 60 days shall be brought and resolved
            exclusively in accordance with the following provisions of this
            Section 7.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Agreement to Binding, Exclusive, Arbitration">
          <LegalNoticeText>
            <strong>(a) Mandatory Binding Arbitration.</strong> All claims,
            disputes and controversies directly or indirectly arising out of or
            in connection with or directly or indirectly relating to these Terms
            or any of the matters or transactions contemplated by these Terms
            (for the avoidance of doubt, including any claim seeking to
            invalidate, or alleging that, all or any part of these Terms is
            unenforceable, void or voidable) (such claims, disputes and
            controversies, collectively, “ Disputes ”) shall be resolved by
            confidential, binding arbitration to be seated in the British Virgin
            Islands and conducted in the English language in the BVI
            International Arbitration Centre (BVI IAC) Arbitration Rules (the
            “Rules ”). The arbitrator shall be appointed in accordance with the
            procedures set out in the Rules. The award or decision of the
            arbitrator shall be final and binding upon the parties and the
            parties expressly waive any right under the laws of any jurisdiction
            to appeal or otherwise challenge the award, ruling or decision of
            the arbitrator. The judgment of any award or decision may be entered
            in any court having competent jurisdiction to the extent necessary.
            If the Company elects to have a Dispute resolved by arbitration
            pursuant to this provision, no party hereto shall (or shall permit
            its representatives to) commence, continue or pursue any Dispute in
            any court; provided, however, that the Company shall be entitled to
            obtain an injunction or injunctions to prevent breaches of this
            provision and to enforce specifically the terms and provisions
            thereof, this being in addition to any other remedy to which the
            Company is entitled at law or in equity, and the parties hereto
            hereby waive the requirement of any posting of a bond in connection
            with such injunctive relief or specific performance.
          </LegalNoticeText>
          <LegalNoticeText>
            <strong>(b) Waiver of Jury Trial.</strong> The parties hereby
            acknowledge, represent and warrant that they understand that:
          </LegalNoticeText>
          <ul>
            <li>
              (i) there is no judge or jury in arbitration, and, absent this
              mandatory provision, the parties would have the right to sue in
              court and have a jury trial concerning Disputes;
            </li>

            <li>
              (ii) in some instances, the costs of arbitration could exceed the
              costs of litigation;
            </li>

            <li>
              (iii) the right to discovery may be more limited in arbitration
              than in court; and
            </li>

            <li>
              (iv) court review of an arbitration award is limited. Each of the
              parties hereto hereby irrevocably waives any and all right to
              trial by jury in any action, suit or other legal proceeding
              arising out of or related to these Terms or the transactions
              contemplated hereby.
            </li>

            <li>
              (v) Except to the extent necessary to enforce their respective
              rights under these Terms or as otherwise required by applicable
              law, the parties undertake to maintain confidentiality as to the
              existence and events of the arbitration proceedings and as to all
              submissions, correspondence and evidence relating to the
              arbitration proceedings. This provision shall survive the
              termination of the arbitral proceedings.
            </li>
          </ul>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Court Jurisdiction">
          <LegalNoticeText>
            To the extent that any court is required to weigh on the
            enforceability of the arbitration provision above, to enforce any
            judgment of the arbitrator, then, without limiting Section 7.3 or
            any other provision of this Agreement, the User (A) hereby
            irrevocably and unconditionally submit to the jurisdiction of the
            courts of the British Virgin Islands for such purpose; (B) agrees
            not to commence any suit, action or other proceeding arising in
            connection with or based upon this instrument or the matters
            contemplated by this instrument except before the courts of the
            British Virgin Islands, and (C) hereby waives, and agrees not to
            assert, by way of motion, as a defense, or otherwise, in any such
            suit, action or proceeding, any claim that it is not subject
            personally to the jurisdiction of the above-named courts, that its
            property is exempt or immune from attachment or execution, that the
            suit, action or proceeding is brought in an inconvenient forum, that
            the venue of the suit, action or proceeding is improper or that this
            instrument or the subject matter hereof or thereof may not be
            enforced in or by such court.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Class Action Waiver">
          <LegalNoticeText>
            <strong>(a) No Class Actions Permitted.</strong> All Users hereby
            agree that any arbitration or other permitted action with respect to
            any Dispute shall be conducted in their individual capacities only
            and not as a class action or other representative action, and the
            Users expressly waive their right to file a class action or seek
            relief on a class basis. USERS SHALL BRING CLAIMS AGAINST TERMINAL
            OPERATOR OTHER ONLY IN THEIR INDIVIDUAL CAPACITY, AND NOT AS A
            PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE
            PROCEEDING.
          </LegalNoticeText>
          <LegalNoticeText>
            <strong>
              (b) Agreements if Class Action Waiver Unenforceable.
            </strong>{" "}
            If any court or arbitrator makes a final, binding and non-appealable
            determination that the class action waiver set forth in this Section
            7.5 is void or unenforceable for any reason or that an arbitration
            can proceed on a class basis, then the arbitration provision set
            forth above shall be deemed null and void with respect to any
            Dispute that would thus be required to be resolved by arbitration
            on a class basis, and the parties shall be deemed to have not
            agreed to arbitrate such Dispute. In the event that, as a result
            of the application of the immediately preceding sentence or
            otherwise, any Dispute is not subject to arbitration, the parties
            hereby agree to submit to the personal and exclusive jurisdiction
            of and venue in the courts located in the British Virgin Islands
            and to accept service of process by mail with respect to such
            Dispute, and hereby waive any and all jurisdictional and venue
            defenses otherwise available with respect to such Dispute.
          </LegalNoticeText>
        </LegalNoticeSubsection>
      </>
    ),
  },
  {
    title: "Miscellaneous",
    content: (
      <>
        <LegalNoticeSubsection title="Headings">
          <LegalNoticeText>
            The headings and captions contained in these Terms are for
            convenience of reference only, shall not be deemed to be a part of
            these Terms and shall not be referred to in connection with the
            construction or interpretation of these Terms.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Successors and Assigns">
          <LegalNoticeText>
            These Terms shall inure to the benefit of Terminal Operator, the
            Users, and their respective permitted successors, permitted assigns,
            permitted transferees and permitted delegates and shall be binding
            upon all of the foregoing persons and any person who may otherwise
            succeed to any right, obligation or liability under these Terms by
            operation of law or otherwise. A User shall not assign any of a User
            rights or delegate any of a User liabilities or obligations under
            these Terms to any other person without Terminal Operator&rsquo;s
            advance written consent. The Terminal Operator may freely assign,
            transfer or delegate its rights, obligations and liabilities under
            these Terms to the maximum extent permitted by applicable law.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Severability">
          <LegalNoticeText>
            In the event that any provision of these Terms, or the application
            of any such provision to any person or set of circumstances, shall
            be determined by an arbitrator or court of competent jurisdiction to
            be invalid, unlawful, void or unenforceable to any extent: (a) the
            remainder of these Terms, and the application of such provision to
            persons or circumstances other than those as to which it is
            determined to be invalid, unlawful, void or unenforceable, shall not
            be impaired or otherwise affected and shall continue to be valid and
            enforceable to the fullest extent permitted by law; and (b) Terminal
            Operator shall have the right to modify these Terms so as to effect
            the original intent of the parties as closely as possible in an
            acceptable manner in order that the transactions contemplated hereby
            be consumed as originally contemplated to the fullest extent
            possible.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Force Majeure">
          <LegalNoticeText>
            Terminal Operator shall not incur any liability or penalty for not
            performing any act or fulfilling any duty or obligation hereunder or
            in connection with the matters contemplated hereby by reason of any
            occurrence that is not within its control (including any provision
            of any present or future law or regulation or any act of any
            governmental authority, any act of God or war, any epidemic or
            pandemic, or the unavailability, disruption or malfunction of the
            Internet, the World Wide Web or any other electronic network, the
            Blockchain Systems or Third Party Smart Contract Systems or Third
            Party Protocols or any aspect thereof, or the other software,
            networks and infrastructure that enables Terminal Operator to
            provide Terminal), it being understood that Terminal Operator shall
            use commercially reasonable efforts, consistent with accepted
            practices in the industries in which Terminal Operator operates, as
            applicable, to resume performance as soon as reasonably practicable
            under the circumstances.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Amendments and Modifications">
          <LegalNoticeText>
            These Terms may only be amended, modified, altered or supplemented
            by or with the written consent of the Terminal Operator. Terminal
            Operator reserves, the right, in its sole and absolute discretion,
            to amend, modify, alter or supplement these Terms from time to time.
            The most current version of these Terms will be posted on the
            Terminal. Any changes or modifications will be effective immediately
            upon the modified Agreement being posted to Terminal. A User shall
            be responsible for reviewing and becoming familiar with any such
            modifications. Each User hereby waives any right such User may have
            to receive specific notice of such changes or modifications. Use of
            Terminal by a User after any modification of these Terms constitutes
            the User&rsquo;s acceptance of the modified terms and conditions. If
            a User does not agree to any such modifications, the User must
            immediately stop using Terminal.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="No Implied Waivers">
          <LegalNoticeText>
            No failure or delay on the part of Terminal Operator in the exercise
            of any power, right, privilege or remedy under these Terms shall
            operate as a waiver of such power, right, privilege or remedy; and
            no single or partial exercise of any such power, right, privilege or
            remedy shall preclude any other or further exercise thereof or of
            any other power, right, privilege or remedy. Terminal Operator shall
            not be deemed to have waived any claim arising out of these Terms,
            or any power, right, privilege or remedy under these Terms, unless
            the waiver of such claim, power, right, privilege or remedy is
            expressly set forth in a written instrument duly executed and
            delivered on behalf of Terminal Operator, and any such waiver shall
            not be applicable or have any effect except in the specific instance
            in which it is given.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Entire Agreement">
          <LegalNoticeText>
            These Terms constitute the entire agreement between the parties
            relating to the subject matter hereof and supersede all prior or
            contemporaneous agreements and understandings, both written and
            oral, between the parties with respect to the subject matter hereof.
          </LegalNoticeText>
        </LegalNoticeSubsection>
        <LegalNoticeSubsection title="Rules of Interpretation">
          <ul>
            <li>
              &ldquo;hereof,&rdquo; &ldquo;herein,&rdquo;
              &ldquo;hereunder,&rdquo; &ldquo;hereby&rdquo; and words of similar
              import will, unless otherwise stated, be construed to refer to
              these Terms as a whole and not to any particular provision of
              these Terms;
            </li>
            <li>
              &ldquo;include(s)&rdquo; and &ldquo;including&rdquo; shall be
              construed to be followed by the words &ldquo;without
              limitation&rdquo;;
            </li>
            <li>
              &ldquo;or&rdquo; shall be construed to be the &ldquo;inclusive
              or&rdquo; rather than &ldquo;exclusive or&rdquo; unless the
              context requires otherwise;
            </li>
            <li>
              any rule of construction to the effect that ambiguities are to be
              resolved against the drafting party shall not be applied in the
              construction or interpretation of these Terms;
            </li>
            <li>
              section titles, captions and headings are for convenience of
              reference only and have no legal or contractual effect;
            </li>
            <li>
              whenever the context requires: the singular number shall include
              the plural, and vice versa; the masculine gender shall include the
              feminine and neuter genders; the feminine gender shall include the
              masculine and neuter genders; and the neuter gender shall include
              the masculine and feminine genders; and
            </li>
            <li>
              except as otherwise indicated, all references in these Terms to
              &ldquo;Sections,&rdquo; &ldquo;clauses,&rdquo; etc., are intended
              to refer to sections, clauses, etc. of these Terms.
            </li>
          </ul>
        </LegalNoticeSubsection>
      </>
    ),
  },
];

export const PRIVACY_POLICY_ARTICLES: IArticleConfig[] = [
  {
    title: "Personal data",
    content: (
      <>
        <LegalNoticeText>
          Pursuant to the Regulation on the protection of natural persons with
          regard to the processing of personal data ("Regulation"), Terminal App
          informs that it is the administrator of personal data provided by the
          User in connection with or when using the Website. Personal data are
          processed in accordance with the Regulation and, in cases required by
          its content, with the User's consent.
        </LegalNoticeText>
        <LegalNoticeText>
          Terminal App only collects data that is necessary to conclude a
          contract and provide the service selected by the User, answer
          questions addressed to Terminal App, market its own services and
          provide information about its offer.
        </LegalNoticeText>
        <LegalNoticeText>
          During registration, verification or placing an order for the service,
          Terminal App collects the data provided by the User in the forms
          provided.
        </LegalNoticeText>
        <LegalNoticeText>
          In cases required by the provisions of the Regulation, the User
          consents to the processing of his or her personal data in electronic
          form, by checking the appropriate box during registration or other
          procedure aimed at enabling the use of the Website. The user may
          withdraw consent to the processing of personal data at any time.
        </LegalNoticeText>
        <LegalNoticeText>
          Providing data marked as required on the Website is voluntary, but
          necessary to conclude a contract and provide the service to the User
          or register the User on the Website. If the User does not provide the
          required personal data, it will not be possible to register the User
          on the Website or conclude a contract and provide the service to the
          User.
        </LegalNoticeText>
        <LegalNoticeText>
          The basis for the processing of personal data provided by the User by
          Terminal App is the need to perform the contract and, at the User's
          request, to take the necessary actions before its conclusion.
        </LegalNoticeText>
        <LegalNoticeText>
          In the case of marketing of its own services and Terminal App sending
          information about its offer to the e-mail address provided by the
          User, the basis for the processing of the User's personal data is the
          implementation of the legally justified interest of Terminal App.
        </LegalNoticeText>
        <LegalNoticeText>
          Data processing to enable Terminal App to provide information about
          its products and services enables the User to be provided with
          information about the current offer.
        </LegalNoticeText>
        <LegalNoticeText>
          In the case of providing the Newsletter service to the User, the basis
          for data processing is the User's consent, which the User may revoke
          at any time.
        </LegalNoticeText>
        <LegalNoticeText>
          The User's personal data will be stored in a form that allows the User
          to be identified no longer than is necessary for the purposes for
          which the personal data are collected and lawfully processed.
        </LegalNoticeText>
        <LegalNoticeText>
          Personal data will therefore be stored for the period necessary to
          perform the contract and provide the service selected by the User.
        </LegalNoticeText>
        <LegalNoticeText>
          After this time, the data will be processed for the period necessary
          to resolve any potential disputes that may arise in connection with
          the services provided, e.g. related to claims (this period will
          include the limitation period for claims arising from the contract, in
          accordance with applicable regulations).
        </LegalNoticeText>
        <LegalNoticeText>
          The specificity of the Website means that in most cases the
          Administrator is obliged by law to process data even when the User no
          longer uses the Website. This applies primarily to regulations on
          counteracting money laundering and terrorist financing. Such
          obligations also come from tax and accounting regulations. To some
          extent, even if the account on the Website is deleted, the
          Administrator will process personal data.
        </LegalNoticeText>
      </>
    ),
  },
  {
    title: "Transmission of personal data",
    content: (
      <>
        <LegalNoticeText>
          The processing of the User's personal data or other data referred to
          in the Privacy Policy may be entrusted on the basis of a written
          contract concluded in accordance with the provisions of the Regulation
          towards entities providing services to Terminal App, e.g. hosting,
          administration, maintenance and management of the Website.
        </LegalNoticeText>
        <LegalNoticeText>
          Subject to the above provisions, the collected personal data will not
          be disclosed to any other persons or institutions, unless it is
          required by applicable law or it is necessary to achieve the purpose
          of personal data processing and an appropriate agreement is concluded
          to guarantee the protection of the User's rights and privacy.
        </LegalNoticeText>
      </>
    ),
  },
  {
    title: "User rights and obligations",
    content: (
      <>
        <LegalNoticeText>
          The User has the right to access the content of personal data and the
          right to request supplementation, updating, transfer, limitation of
          processing, rectification of personal data, temporary or permanent
          suspension of their processing or their deletion if they are
          incomplete, outdated, untrue or were collected in violation of the law
          or are no longer necessary to achieve the purpose for which they were
          collected.
        </LegalNoticeText>
        <LegalNoticeText>
          In the case of processing the User's data for the purpose of marketing
          the service and own products, the User may at any time submit a
          written and substantiated request to discontinue the processing of his
          data due to his special situation or object to the processing of his
          data for this purpose.
        </LegalNoticeText>
        <LegalNoticeText>
          Terminal App enables the User to delete his or her personal data from
          the data set at the User's request or pursuant to the provisions of
          the Regulation.
        </LegalNoticeText>
        <LegalNoticeText>
          Terminal App may refuse to delete personal data if the User has
          violated the Website regulations or applicable law, and the retention
          of personal data is necessary to explain the circumstances of the
          violation and determine the User's liability.
        </LegalNoticeText>
        <LegalNoticeText>
          If the User places any personal data of other people on the Terminal
          App Website (including their name and surname, address, telephone
          number or e-mail address), he or she may do so only provided that the
          provisions of applicable law and the personal rights of these persons
          are not violated.
        </LegalNoticeText>
      </>
    ),
  },
  {
    title: "Additional information about cookies",
    content: (
      <>
        <LegalNoticeText>
          Cookies are text files that are saved on the disk of the User's end
          device and are used to recognize the User's device when reconnecting
          to the website that uses cookies.
        </LegalNoticeText>
        <LegalNoticeText>
          Cookies are not used to determine the User's identity, but allow us to
          more precisely determine the individual needs of the User using a
          given device and thus offer better services and more tailored to his
          requirements, as well as facilitate connection with websites of
          interest to the User.
        </LegalNoticeText>
        <LegalNoticeText>
          Cookies are also used by Terminal App for the following purposes:
        </LegalNoticeText>
        <ol>
          <li>
            statistical - which allows for the creation of statistics on the
            functioning of websites and User visits for internal purposes and
            for contractors,
          </li>
          <li>
            presentation and personalization of marketing messages displayed on
            a given end device.
          </li>
        </ol>
        <LegalNoticeText>
          Deleting cookies may result in the loss of the ability to use some
          functionalities of the Terminal App website.
        </LegalNoticeText>
      </>
    ),
  },
  {
    title: "Other data",
    content: (
      <>
        <LegalNoticeText>
          In some cases, Terminal App collects certain types of information
          automatically during the User's visit to the Website or via e-mail
          addresses. Such operational data related to the use of the Website (IP
          address and port, browser ID, addresses of visited pages) are stored
          in aggregate and anonymized form and are not made available to third
          parties. This data is used to better understand and improve the
          operation, functionality and efficiency of the Website and to generate
          statistics helpful in administering the Website.
        </LegalNoticeText>
        <LegalNoticeText>
          Users' data are also processed by Terminal App for the purpose of
          automated processing in the form of profiling. Profiling means any
          form of automated processing of personal data by Terminal App, which
          involves using Users' personal data to evaluate certain personal
          factors, in particular to analyze or forecast Users' preferences,
          reliability, behavior and location. Each User has the right to object
          to profiling by Terminal App if he or she considers that profiling
          violates his or her rights and freedoms, unless the data controller
          demonstrates that its own interests override the rights and freedoms
          of the person. The Service User may object to profiling free of charge
          in any form via available communication channels with Terminal App.
        </LegalNoticeText>
      </>
    ),
  },
  {
    title: "Data security",
    content: (
      <>
        <LegalNoticeText>
          In order to protect the User's personal data against disclosure to
          unauthorized persons, removal by an unauthorized person, processing in
          violation of applicable regulations and change, loss, damage or
          destruction, technical and organizational measures are used to ensure
          protection of processed personal data appropriate to the threats and
          categories of protected data.
        </LegalNoticeText>
        <LegalNoticeText>
          In particular, the Administrator uses technical measures to prevent
          data from being obtained or modified by unauthorized persons. The
          Administrator protects data sets against access by unauthorized
          entities and provides access to the User's account only after
          authentication including providing an individual login and password.
          Moreover, the data provided by the User when filling out and
          submitting online forms is encrypted using SSL certificates.
        </LegalNoticeText>
      </>
    ),
  },
  {
    title: "Contact",
    content: (
      <>
        <LegalNoticeText>
          The Website User may contact Terminal App at any time to obtain
          information on whether and how Terminal App uses or intends to use his
          or her personal data, as well as to report any events affecting the
          security of information and data transmission. For this purpose, the
          User should use an e-mail address.
        </LegalNoticeText>
      </>
    ),
  },
  {
    title: "Change of the privacy policy",
    content: (
      <>
        <LegalNoticeText>
          Terminal App reserves the right to make changes to the Privacy Policy
          and at the same time ensures that the User's rights arising from this
          document will not be limited without his consent. Any changes to the
          Privacy Policy will be published on the padre.gg website.
        </LegalNoticeText>
      </>
    ),
  },
  {
    title: "Contact with supervisory authority",
    content: (
      <>
        <LegalNoticeText>
          In all matters related to the processing of the User's personal data
          and the application and implementation of this Privacy Policy, the
          User has the right to lodge a complaint with the supervisory authority
          in the field of personal data protection to which the case concerns.
        </LegalNoticeText>
      </>
    ),
  },
];
